import * as React from 'react';
import { Summary } from '@grandvisionhq/common';
import { Util } from '@grandvisionhq/forms';
import { useIntl, useSelector } from '@grandvisionhq/state';
import { ShippingObjectTypes } from '../../../../state.js';
import { getDeliveryAddress } from '../../../selectors.js';
import { BillingAndDeliveryForm } from './BillingAndDeliveryForm.js';

const BillingAndDeliveryFormContainer = ({ addressSummary , billingAddressForm , className , deliveryAddressForm , editRef , handleModalOpen , isDelivery , isDeliveryExpress , onToggleDeliveryAddress , shippingDetails , showBillingAddressSummary ,  })=>{
    const { getLabel  } = useIntl();
    const deliveryAddress = useSelector(getDeliveryAddress);
    const billingAddress = shippingDetails ? Util.getValuesFromState(shippingDetails.billingAddress.formData) : {};
    const billingAddressSummary = addressSummary && /*#__PURE__*/ React.createElement(Summary, {
        onEditClick: ()=>handleModalOpen(ShippingObjectTypes.BillingAddress)
        ,
        editRef: editRef
    }, /*#__PURE__*/ React.cloneElement(addressSummary, {
        values: billingAddress
    }));
    const labels = React.useMemo(()=>({
            differentDeliveryAddress: getLabel('checkout.shipment.differentDeliveryAddress'),
            deliveryAddress: getLabel('checkout.deliveryAddress')
        })
    , [
        getLabel
    ]);
    return /*#__PURE__*/ React.createElement(BillingAndDeliveryForm, {
        billingAddressForm: billingAddressForm,
        billingAddressSummary: billingAddressSummary,
        className: className,
        deliveryAddress: deliveryAddress,
        deliveryAddressForm: deliveryAddressForm,
        isDelivery: isDelivery,
        isDeliveryExpress: isDeliveryExpress,
        showBillingAddressSummary: showBillingAddressSummary,
        labels: labels,
        onToggleDeliveryAddress: onToggleDeliveryAddress
    });
};

export { BillingAndDeliveryFormContainer };
//# sourceMappingURL=BillingAndDeliveryFormContainer.js.map
